var map = {
	"./alert-circle.svg": 7238,
	"./bell.svg": 8812,
	"./check.svg": 6469,
	"./checkmark-circle-2.svg": 2342,
	"./chevron-down.svg": 1080,
	"./chevron-left.svg": 6019,
	"./chevron-right.svg": 6097,
	"./clock.svg": 3578,
	"./collapse.svg": 3663,
	"./copy.svg": 5881,
	"./expand.svg": 664,
	"./external-link.svg": 5328,
	"./file.svg": 1478,
	"./grad-cap.svg": 8422,
	"./info.svg": 5874,
	"./lab.svg": 3090,
	"./lock.svg": 38,
	"./logo-small.svg": 597,
	"./logo.svg": 31,
	"./magic-wand.svg": 5764,
	"./mail.svg": 8915,
	"./message.svg": 6814,
	"./mic-off.svg": 3978,
	"./mic.svg": 7759,
	"./minus.svg": 7064,
	"./options.svg": 412,
	"./pencil.svg": 8830,
	"./plus.svg": 4317,
	"./refresh.svg": 8163,
	"./search.svg": 1015,
	"./users.svg": 9978,
	"./video-off.svg": 2362,
	"./video.svg": 7562,
	"./x.svg": 8488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5390;